<template>
    <div class="container">

        <div class="charg_p">
            <span>
                <el-date-picker v-model="chartTimeValue"
                                :clearable="false"
                                type="daterange" :align="right" unlink-panels
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                :picker-options="pickerOptions2">
                </el-date-picker>

                <el-input clearable v-model="patientName" placeholder="输入推荐人名字查询" style="width: 200px"></el-input>
                <el-select v-model="levelSelected" clearable>
                    <el-option v-for="item in userLevelType" :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
                <el-button type="primary" class="el-icon-search" @click="onSubmit()"></el-button>
            </span>
        </div>
        <template>
            <el-table border :data="tableData" stripe style="width: 100%" :header-cell-style="tableHeaderColor">
                <el-table-column prop="registrationCode" label="注册码" width="400">
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="usedTime" label="使用时间"></el-table-column>
                <el-table-column prop="status" label="状态" width="180"
                                 :filters="[{ text: '已使用', value: '-1' }, { text: '未使用', value: '0' }]"
                                 :filter-method="filterTag" filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status==='0' ? 'danger' : 'success'">
                            {{scope.row.status == '0' ? '未使用' : '已使用'}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="usedUserName"
                        label="使用人">
                </el-table-column>
                <el-table-column
                        prop="refereeUserName"
                        label="推荐人">
                </el-table-column>
            </el-table>
        </template>

        <div class="block">
            <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync=Current
                    :page-size="this.Size"
                    layout="total,prev, pager, next, jumper"
                    :total="this.total">
            </el-pagination>
        </div>
    </div>
</template>

<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .container{
        width: 98%;
        margin-left: 18px;
    }
    .charg_p {
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: right;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }

    .block {
        margin-top: 20px;
        padding-left: 33%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>

<script>
  import {formatDate} from "../../common/date";

  export default {
    data() {
      return {
        right: '',
        levelSelected: '',
        patientName: '',
        userLevelType: [{
          value: '已使用',
          label: '已使用'
        }, {
          value: '未使用',
          label: '未使用'
        }],
        chartTimeValue: [Date.now() - 8.64e7 * 6, Date.now()+8.64e7],
        tableData: [],
        total: 0,
        Current: 1,
        Size: 10,
        currentPage: 1,
        dataList: {},
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        obj: {
          startDate: "",
          endDate: "",
          status: '',
          refereeName: ''
        }
      };
    },
    mounted: function () {
      this.obj = {
        startDate: formatDate(this.chartTimeValue[0], 'yyyy-MM-dd'),
        endDate: formatDate(this.chartTimeValue[1], 'yyyy-MM-dd'),
        status: '',
        refereeName: ''
      };
      this.getinfo();
    },
    methods: {
      getinfo() {
        this.$axios({
          url: '/api/code/produceCodeList/pageNumber/' + this.Current + '/size/' + this.Size,
          method: 'POST',
          data: this.obj
        }).then(res => {
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements;
        }).catch(err => {
          console.log(err.data);
        })
      },
      onSubmit: function () {
        this.Current=1;
          console.log(this.levelSelected+'aa')
          this.obj = {
              startDate: formatDate(this.chartTimeValue[0], 'yyyy-MM-dd'),
              endDate: formatDate(this.chartTimeValue[1], 'yyyy-MM-dd'),
              status: '',
              refereeName: ''
          };
        if (this.chartTimeValue == null || this.chartTimeValue == '') {
          this.$message({
            type: 'danger',
            message: '请检查日期格式'
          });
          return false;
        }

        if (this.levelSelected == '已使用') {
          this.obj.status = '-1'
        } else if (this.levelSelected == '未使用') {
          this.obj.status = '0'
        }else if (this.levelSelected==''){
            this.obj.status==''
        }
        this.obj.refereeName = this.patientName;
          console.log(this.levelSelected+'ss')
          console.log(JSON.stringify(this.obj))

        this.getinfo();
      },
      filterTag(value, row) {
        return row.status === value;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.Size = val;
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.Current = val;
        this.getinfo();
      },

      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";        }
      },
    }


  };
</script>



// WEBPACK FOOTER //
// subscribeCode_Li.vue?28e2c775